import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Row,
  Typography,
  Button,
  Input,
  Spin,
  Form,
} from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import { postSolicitudCambioPassword } from 'api/usuarios/auth';

const { Title } = Typography;

const SolicitudRestablecerContrasena = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = async () => {
    setLoading(true);
    const values = form.getFieldsValue();
    const sent = await postSolicitudCambioPassword(values);
    if (sent) {
      setTimeout(() => {
        navigate(`/recuperacion-de-contrasena?email=${values.email}`);
      }, 300);
    }
    setLoading(false);
  };

  const rules = {
    email: [
      {
        type: 'email',
        message: 'Ingrese un correo electrónico válido.',
      },
      {
        required: true,
        message: 'El campo es requerido',
      },
    ],
  };

  return (
    <Spin
      tip="Loading..."
      spinning={loading}
      style={{ width: '100%', height: '100%', justifyContent: 'center' }}
    >
      <Row style={{ width: '100%' }}>
        <Button
          type="link"
          className="auth"
          style={{ textAlign: 'left', padding: 0 }}
          onClick={() => navigate('/inicio-de-sesion')}
        >
          <LeftOutlined />
          {' '}
          Volver
        </Button>
      </Row>
      <Title style={{ fontWeight: 'bold' }} level={3}>
        Recuperar contraseña
      </Title>
      <Form
        name="forgot-pwd-form"
        layout="vertical"
        form={form}
        onFinish={onFinish}
      >
        <Form.Item
          name="email"
          rules={rules.email}
          label="Correo electrónico"
          hasFeedback
        >
          <Input allowClear />
        </Form.Item>
        <Form.Item style={{ marginBottom: 0 }}>
          <Button
            htmlType="submit"
            className="auth-submit-button"
            shape="round"
            block
          >
            Recuperar
          </Button>
        </Form.Item>
      </Form>
    </Spin>
  );
};

export default SolicitudRestablecerContrasena;
